// @flow
import { combineReducers } from 'redux';
import orgs from './orgs';
import listings from './listings';
import search from './search';
import gradPrograms from './gradPrograms';
import idealistDayEvents from './idealistDayEvents';
import type { Action as OrgAction } from '../../actions/orgDashboard/orgs';
import type { Action as ListingsAction } from '../../actions/orgDashboard/listings';
import type { Action as SearchAction } from '../../actions/orgDashboard/search';
import type { Action as GradProgramAction } from '../../actions/orgDashboard/gradPrograms';
import type { Action as IdealistDayEventAction } from '../../actions/orgDashboard/idealistDayEvents';

export default combineReducers<
  {
    orgs: typeof orgs,
    listings: typeof listings,
    search: typeof search,
    gradPrograms: typeof gradPrograms,
    idealistDayEvents: typeof idealistDayEvents
  },
  | OrgAction
  | ListingsAction
  | SearchAction
  | GradProgramAction
  | IdealistDayEventAction
>({
  orgs,
  listings,
  search,
  gradPrograms,
  idealistDayEvents
});
